/**
 * Cut all non-digit characters from string
 * @param str
 */
export const cutNumberFromString = (str: string) => {
  return str.replace(/\D+/g, '');
};
